
import { sorter, sortTime } from '@/pages/intelligence/utils/sort';
import FacebookGamingIcon from '@/pages/intelligence/assets/svg/dataSource/fbgaming.svg';
import TwitchIcon from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import YouTubeIcon from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';

interface SortParamsType {
  ratioType: 0 | 1
  sortVal: 'desc' | 'asc';
  sortMetric: string;
}
const getMetricValue = (cvm: any, sortParams: SortParamsType) => {
  let metricFir = getPlatform(cvm?.platform, sortParams?.sortMetric);
  return metricFir;
};

export const sortStreamingTableByMetric = (tableData: any[], sortParams: SortParamsType): any[] => {
  if (!Array.isArray(tableData)) {
    return []
  }
  const sortTable = tableData.slice(0);
  if (sortParams?.sortMetric === 'date') {
    sortTable.sort((first, second) => {
      const firstVal = first.date;
      const secondVal = second.date;
      return sortParams?.sortVal === 'asc'
        ? sortTime(secondVal, firstVal)
        : sortTime(firstVal, secondVal);
    });
  } else if (sortParams?.ratioType === 1) {
    sortTable.sort((first, second) => {
      if (first?.app_id === 'total' || second?.app_id === 'total') {
        return 0;
      }
      const firstVal = getMetricValue(first, sortParams)?.growth_ratio;
      const secondVal = getMetricValue(second, sortParams)?.growth_ratio;
      return sortParams?.sortVal === 'asc'
        ? sorter(firstVal, secondVal)
        : sorter(secondVal, firstVal);
    });
  } else {
    sortTable.sort((first, second) => {
      if (first?.app_id === 'total' || second?.app_id === 'total') {
        return 0;
      }
      const firstVal = getMetricValue(first, sortParams)?.value;
      const secondVal = getMetricValue(second, sortParams)?.value;
      return sortParams?.sortVal === 'asc'
        ? sorter(firstVal, secondVal)
        : sorter(secondVal, firstVal);
    });
  }
  return sortTable;
};

export const getPlatform = (objList: any, platform: string) => {//TODO:添加参数 寻找哪个字段 代替name
  if (typeof objList !== 'object') { return null }
  let keys = Object.keys(objList)
  let idx = keys.indexOf(platform)
  if (idx < 0) {
    return null;
  } else {
    let metric = objList[platform]?.metric
    if ((!Array.isArray(metric)) || !(metric?.length)) {
      return null;
    }
    return objList[platform]?.metric[0]
  }
}

export const getMetrics = (list, metric, metricName) => {//TODO:添加参数 寻找哪个字段 代替name
  if (list && list?.length > 0) {
    for (let i = 0; i < list?.length; i++) {
      if (list[i][metricName] === metric) {
        return list[i];
      }
    }
  }
}
export const getImgfromName = (name: string) => {
  switch (name) {
    case 'facebook':
    case 'Facebook':
      return FacebookGamingIcon;
    case 'twitch':
    case 'Twitch':
      return TwitchIcon;
    case 'ytg':
    case 'Youtube':
      return YouTubeIcon;
    default:
      return;
  }
}

const valueFormatFun = (val: any) => {
  return isNaN(parseInt(val)) ? '-' : mathFormat(val);
} //展示的值格式

export const hasMarketImgTooltip = (param: any, letTitle?: string, rightTitle?: string) => {
  let leftStr = '', rightStr = '', totalNum = 0
  for (let i = 0; i < param?.length; i++) {

    const nameVal = param[i]?.seriesName || '';
    let value: any = '';
    if (typeof param[i].value === 'object') {
      value = param[i].value[1];
    } else {
      value = param[i].value;
    }
    totalNum = totalNum + (value * 1);
    leftStr += `<div>
    ${param[i].marker}
    <img  style="width:16px;height:16px;"src="${getImgfromName(nameVal)}"/>
    <span style="color:#000000;opacity:0.65;font-size:12px;"> ${nameVal}</span>
    </div>`
    rightStr += ` <div style="color:#000000;font-weight:bold;text-align:right;" >
    ${valueFormatFun(value)}
    </div>`
  }
  let returnStr = `
      <div style="font-size:12px;margin-bottom:4px;">
          <div style="color:#000000;opacity:0.45;text-align: left;margin-right:20px;display:inline-block;">
              ${letTitle}
          </div>
          <div style="color:#000000;opacity:0.45;float:right;display:inline-block;">
              ${rightTitle}
          </div>
      </div>`;
  returnStr += `<div style="font-size:12px;display:flex;justify-content:space-between;">
      <div  style="margin-right:16px;"><div>
      <span style="color:#000000;opacity:0.65;font-size:12px;"> ${'Sum'}</span>
      </div>${leftStr}</div>      
      <div><div style="color:#000000;font-weight:bold;text-align:right;" >
      ${valueFormatFun(totalNum)}
      </div>${rightStr}</div>
    </div>`;
  returnStr += '</div>'
  return returnStr;
};